import { Link } from 'react-router-dom';
import Logo from '../../img/logo.jpeg';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about' },
    { name: 'Technology', href: '/technology' },
  ];

  const legalLinks = [
    { name: 'Privacy Policy', href: '/privacy-policy' },
    { name: 'Terms of Service', href: '/terms-of-service' },
  ];

  return (
    <footer className="relative bg-slate-900 overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 bg-grid opacity-5"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center space-x-3 mb-6 group">
              <img
                src={Logo}
                alt="OffshoreBrücke Logo"
                className="w-11 h-11 object-contain rounded-xl transition-transform duration-300 group-hover:scale-105"
              />
              <span className="text-2xl font-bold text-white">OffshoreBrücke</span>
            </Link>
            <p className="text-slate-300/80 mb-6 max-w-md leading-relaxed">
              The digital bridge for EU-India SME expansion. Empowering European businesses
              for seamless market expansion and offshoring with AI-powered solutions.
            </p>
            {/* Social Links */}
            <div className="flex space-x-3">
              <a 
                href="https://www.linkedin.com/company/offshorebr%C3%BCcke/" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center text-slate-300 hover:bg-accent hover:text-white transition-all duration-300 hover:-translate-y-0.5"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a 
                href="mailto:offshorebruecke@gmail.com" 
                className="w-10 h-10 bg-white/10 rounded-xl flex items-center justify-center text-slate-300 hover:bg-accent hover:text-white transition-all duration-300 hover:-translate-y-0.5"
              >
                <i className="ri-mail-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-5">Navigation</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-slate-300/80 hover:text-white transition-colors duration-300 text-sm flex items-center group"
                  >
                    <span className="w-0 group-hover:w-3 h-px bg-accent transition-all duration-300 mr-0 group-hover:mr-2"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
              {legalLinks.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.href} 
                    className="text-slate-300/80 hover:text-white transition-colors duration-300 text-sm flex items-center group"
                  >
                    <span className="w-0 group-hover:w-3 h-px bg-accent transition-all duration-300 mr-0 group-hover:mr-2"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold text-slate-400 uppercase tracking-wider mb-5">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start text-slate-300/80 text-sm">
                <div className="w-8 h-8 bg-white/5 rounded-lg flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-accent text-sm"></i>
                </div>
                <a href="mailto:offshorebruecke@gmail.com" className="hover:text-white transition-colors duration-300 mt-1.5">
                  offshorebruecke@gmail.com
                </a>
              </li>
              <li className="flex items-start text-slate-300/80 text-sm">
                <div className="w-8 h-8 bg-white/5 rounded-lg flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-accent text-sm"></i>
                </div>
                <span className="mt-1.5">+49 173 9712627<br />+49 17646546971</span>
              </li>
              <li className="flex items-start text-slate-300/80 text-sm">
                <div className="w-8 h-8 bg-white/5 rounded-lg flex items-center justify-center mr-3 mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-accent text-sm"></i>
                </div>
                <span className="mt-1.5">Munich, Germany</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {currentYear} OffshoreBrücke. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy-policy" className="text-slate-400 hover:text-white text-sm transition-colors duration-300">
                Privacy
              </Link>
              <Link to="/terms-of-service" className="text-slate-400 hover:text-white text-sm transition-colors duration-300">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
